import { authHostname } from 'api/ApiConfig';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from 'utilities/auth';

export const Login = () => {
    const [search] = useSearchParams();
    const { isAuthenticated, isLoading, loginWithCode, error } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (isAuthenticated) {
            navigate('/');
        }

        const lang = search.get('lang');
        if (lang) {
            localStorage.setItem('i18nextLng', lang);
            localStorage.setItem('language', lang);
        }

        const callback = `${window.location.origin}/callback`;
        const searchParams = new URLSearchParams();
        searchParams.append('client_id', 'public-client');
        searchParams.append('redirect_uri', callback);
        searchParams.append('scope', 'openid email profile federated:id');
        searchParams.append('response_type', 'code');
        searchParams.toString();

        sessionStorage.setItem('callbackURL', authHostname());

        window.location.href = `${authHostname()}/dex/auth?${searchParams.toString()}#signin`;
    }, []);

    return null;
};
